import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  TableContainer,
  Paper,
  Button,
  IconButton,
  Typography,
  Box,
  Menu,
  MenuItem,
  Pagination,
  PaginationItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Drawer,
  Alert,
  Snackbar,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { styled } from "@mui/material/styles";
import AddUsers from "./AddUser";
import ViewUser from "./ViewUser";
import Role from "./Roles"; // Update the path as necessary
import CountryFilter from "./Filters/UserFilters/CountryFilter";
import { api, get, put } from "../../../utils/api";
import CompanyFilter from "./Filters/UserFilters/CompanyFilter";
import RoleFilter from "./Filters/UserFilters/UserRoleFilter";
import UserDateFilter from "./Filters/UserFilters/UserDateFilter";
import FilterSidebar from "../../../Components/Masters/Filter/FilterSidebar";
import ApplyButton from "./Filters/ApplyButton";
import ResetButton from "./Filters/ResetButton";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import FacilityFilter from "./Filters/UserFilters/FacilityFilter";
import FunctionalityOfRole from "./Filters/UserFilters/FunctionOfRole";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import MainSidebar from "../../../Layout/MainSidebar";
import { useUser } from "../../../context/AuthContext";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import NoDataFound from "../../../Components/Masters/NoDataFound";
import PaginationBox from "../../../Components/Masters/Pagination";
import GroupAdminSidebar from "../../../Layout/GroupAdminSidebar";
import TrialUserSidebar from "../../../Layout/TrailUserSidebar";
const User = () => {
  const { user } = useUser();

  let companyUser = user?.companyAdmin;
  const currentUserId = user?._id;
  const tableContainerRef = useRef(null);

  const [showRoles, setShowRoles] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUserIndex, setSelectedUserIndex] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [indexUser, setindexUser] = useState(null);
  const [indexUserView, setindexUserView] = useState(0);
  const [isDrawerOpenEdit, setIsDrawerOpenEdit] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [users, setUsers] = useState([]);
  const [countryFilter, setCountryFilter] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [companyFilterOpen, setCompanyFilterOpen] = useState(false);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [roleFilters, setRoleFilters] = useState([]);
  const [facilityFilter, setFacilityFilter] = useState([]);
  const [functionalityOfRoleFilter, setFunctionalityOfRoleFilter] = useState(
    []
  );
  const [isShortContent, setIsShortContent] = useState(false);
  const [DeleteIndex, setDeleteIndex] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [errors, setErrors] = useState({
    Date: false,
    Role: false,
    Country: false,
    CompanyName: false,
    Facility: false,
    FunctionalityOfRole: false,
  });

  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Country: false,
    Role: false,
    "Company Name": false,
    Facility: false,
    FunctionalityOfRole: false,
  });

  // let filterList = ["Date", "Country", "Company Name", "Facility", "Role"];
  const filters = companyUser
    ? ["Date", "Country"]
    : ["Date", "Country", "Role"];

  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("Date");

  const fetchUsers = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    setLoading(true);

    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        limit: rowsPerPage,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
      }).toString();
      const response = await get(`${api}/auth/getAllUsers?${queryParams}`);
      console.log(response?.data, "dataCode");
      if (response?.data) {
        setUsers(response.data.users);
        setTotalPages(response.data.totalPages);
      } else {
        console.error(
          "Error fetching users:",
          response?.error || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [page, rowsPerPage, sortConfig]);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight;
      const screenHeight = window.innerHeight;
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, []);

  const handleFilterChange = (selectedCountries) => {
    setCountryFilter(selectedCountries);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // fetchUsers({ ...filters, page: newPage });
  };

  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const handleMenuClick = (event, index, user) => {
    setAnchorEl(event.currentTarget);
    setSelectedUserIndex(index);
    setindexUserView(user);
    setindexUser(index);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedUserIndex(null);
  };

  const handleView = () => {
    // setindexUserView(selectedUserIndex)
    //  console.log("hii",index)
    setAnchorEl(null);
    setSelectedUserIndex(null);
    setIsDrawerOpenEdit(true);
    //  setViewInner(true)
    // openDrawerEdit();
  };
  const handleEdit = () => {
    setAnchorEl(null);
    setSelectedUserIndex(null);
    setIsDrawerOpen(true);
    setIsDrawerOpenEdit(false);
  };
  const canDeleteUser = (targetUser) => {
    const isCurrentUser =
      currentUserId && String(targetUser?._id) === String(currentUserId);
    const isMainCompanyAdmin =
      targetUser?.companyAdmin && !targetUser?.isSubCompanyAdmin;
    const isSubCompanyAdminDeletingCompanyAdmin =
      user?.isSubCompanyAdmin && isMainCompanyAdmin;
    const isUnauthorizedFacilityManagerDeletion =
      targetUser?.facilityManger && !companyUser;

    return (
      !isCurrentUser &&
      !isSubCompanyAdminDeletingCompanyAdmin &&
      !isUnauthorizedFacilityManagerDeletion
    );
  };

  const handleDelete = (targetUser) => {
    if (!canDeleteUser(targetUser)) {
      handleMenuClose();
      return;
    }

    setDeleteIndex(targetUser._id);
    setDeleteDialog(true);
    setAnchorEl(null);
    setSelectedUserIndex(null);
  };

  const handleDeleteAggree = async () => {
    await put(`${api}/auth/DeleteUser?Id=${DeleteIndex}`)
      .then((res) => {
        console.log(res, "User deleted");
        setDeleteDialog(false);
        setsnackOpen({
          open: true,
          message: "User deleted successfully",
          severity: "success",
        });

        const updatedUsers = users.filter(
          (item) => item._id !== res.data.data._id
        );
        setUsers(updatedUsers);
        // if (updatedUsers.length < rowsPerPage && page < totalPages) {
        //   fetchNextPageData();
        // }
        setSelectedUserIndex(null);
      })
      .catch((err) => {
        console.error("Error deleting user:", err);
        setsnackOpen({
          open: true,
          message: err?.response?.data?.message || "Failed to delete user",
          severity: "error",
        });
      });
  };

  // Fetch the next page of users to fill the current page
  const fetchNextPageData = () => {
    const nextPage = page + 1; // Get the next page

    const queryParams = new URLSearchParams({
      page: nextPage,
      limit: rowsPerPage,
      sortField: sortConfig.key,
      sortOrder: sortConfig.direction,
    }).toString();

    fetch(`${api}/auth/getAllUsers?${queryParams}`)
      .then((response) => response.json())
      .then((data) => {
        // Append next page's users to the current list
        setUsers((prevUsers) => [...prevUsers, ...data.users]);
      })
      .catch((error) => {
        console.error("Error fetching next page of users:", error);
      });
  };

  const handleApplyFilters = () => {
    // Reset to first page when applying filters
    setPage(1);
    fetchUsers({
      country: selectedCountries.join(","),
      companyName: selectedCompanies.join(","),
      role: roleFilters.join(","),
      facility: facilityFilter.join(","),
      functionalityOfRole: functionalityOfRoleFilter.join(","),
      startDate: startDate ? startDate.format("YYYY-MM-DD") : "",
      endDate: endDate ? endDate.format("YYYY-MM-DD") : "",
    });

    setDrawerFilterOpen(false);
    handleAppliedFilters();
  };

  const filtersToApply = {
    country: selectedCountries.join(","),
    companyName: selectedCompanies.join(","),
    role: roleFilters.join(","),
    facility: facilityFilter.join(","),
    FunctionalityOfRole: functionalityOfRoleFilter.join(","),
    startDate: startDate ? startDate.format("YYYY-MM-DD") : "",
    endDate: endDate ? endDate.format("YYYY-MM-DD") : "",
  };
  // Applying reset filters
  const handleResetFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedCountries([]);
    setRoleFilters([]);
    setFacilityFilter([]);
    setFunctionalityOfRoleFilter([]);
    setSelectedCompanies([]);
    setAppliedFilters({});
    setIsFiltersApplied(false);
    fetchUsers({});
    setErrors({});
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = startDate || endDate ? true : false;
    const isCountryApplied = selectedCountries.length > 0;
    const isRoleApplied = roleFilters.length > 0;
    const isFacilityApplied = facilityFilter.length > 0;
    // const isFunctionalityOfRoleApplied = functionalityOfRoleFilter.length > 0;
    const isCompanyNameApplied = selectedCompanies.length > 0;

    setIsFiltersApplied(
      isDateApplied ||
      isCountryApplied ||
      isRoleApplied ||
      isFacilityApplied ||
      // isFunctionalityOfRoleApplied ||
      isCompanyNameApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      Country: isCountryApplied,
      Role: isRoleApplied,
      Facility: isFacilityApplied,
      // FunctionalityOfRole: isFunctionalityOfRoleApplied,
      "Company Name": isCompanyNameApplied,
    }));
  };

  const handleRoleFilterChange = (selectedRoles) => {
    setRoleFilters(selectedRoles);
  };

  const handleFacilityFilterChange = (selectedFacility) => {
    setFacilityFilter(selectedFacility);
  };

  const handleFunctionalityOfRoleFilterChange = (
    selectedFunctionalityOfRole
  ) => {
    setFunctionalityOfRoleFilter(selectedFunctionalityOfRole);
    // Trigger user fetching every time the filter changes
    fetchUsers({
      ...filtersToApply,
      functionalityOfRole: selectedFunctionalityOfRole.join(","),
    });
  };

  const open = Boolean(anchorEl);

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "lightgray",
    },
  }));

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Country":
        return (
          <CountryFilter
            url={`${api}/auth/getAllUsers`}
            onFilterChange={handleFilterChange}
            selectedCountries={selectedCountries}
            setSelectedCountries={setSelectedCountries}
            setErrors={setErrors}
            errors={errors.Country}
          />
        );
      case "Company Name":
        return (
          <CompanyFilter
            open={companyFilterOpen}
            onClose={toggleCompanyFilterDrawer(false)}
            onFilterChange={handleCompanyFilterChange} // Update selectedCompanies
            handleApplyFilters={handleApplyFilters} // Apply the filters on click
            selectedCompanies={selectedCompanies}
            errors={errors.CompanyName}
          />
        );
      case "Role":
        return (
          <RoleFilter
            onRoleFilterChange={handleRoleFilterChange}
            selectedRoles={roleFilters}
            errors={errors.Role}
          />
        );

      case "Facility":
        return (
          <FacilityFilter
            onRoleFilterChange={handleFacilityFilterChange}
            selectedFacility={facilityFilter}
            errors={errors.Facility}
          />
        );

      case "FunctionalityOfRole":
        return (
          <FunctionalityOfRole
            onRoleFilterChange={handleFunctionalityOfRoleFilterChange}
            selectedFunctionalityOfRole={functionalityOfRoleFilter}
            errors={errors.FunctionalityOfRole}
          />
        );

      case "Date":
        return (
          <UserDateFilter
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            errors={errors.Date}
            setErrors={setErrors}
          />
        );

      default:
        return (
          // <CountryFilter
          //   url={`${api}/auth/getAllUsers`}
          //   onFilterChange={handleFilterChange}
          //   selectedCountries={selectedCountries}
          //   setSelectedCountries={setSelectedCountries}
          //   errors={errors.Country}
          // />
          <UserDateFilter
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            errors={errors.Date}
          />
        );
    }
  };

  const handleAddUser = (i) => {
    setIsDrawerOpen(true);
    setindexUser(i);
    setindexUserView(0);
  };

  const handleCompanyFilterChange = (companyName, checked) => {
    setSelectedCompanies(
      (prevSelectedCompanies) =>
        checked
          ? [...prevSelectedCompanies, companyName] // Add company if checked
          : prevSelectedCompanies.filter((company) => company !== companyName) // Remove company if unchecked
    );
  };

  const toggleCompanyFilterDrawer = (open) => () => {
    setCompanyFilterOpen(open);
  };

  const filterResetWithoutApply = () => {
    // Reset the selected filter only if changes were made
    if (selectedFilter === "Date") {
      setStartDate(null);
      setEndDate(null);
    } else if (selectedFilter === "Country") {
      setSelectedCountries([]);
    } else if (selectedFilter === "Company Name") {
      setSelectedCompanies([]);
    } else if (selectedFilter === "Facility") {
      setFacilityFilter([]);
    } else if (selectedFilter === "Role") {
      setRoleFilters([]);
    }
    setDrawerFilterOpen(false); // Close the drawer without resetting everything
  };

  const handleFilterDrawer = () => {
    filterResetWithoutApply();
  };

  if (showRoles) {
    return <Role />;
  }

  return (
    <MainDashboardLayout
      sidebar={
        user?.groupManager ? (
          <GroupAdminSidebar />
        ) : user?.isTrialUser ? (
          <TrialUserSidebar />
        ) : (
          <MainSidebar />
        )
      }
    >
      <Unauthorized requiredModule="Setup | Roles & Permission">
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <Box sx={{ width: 600 }}>
            <Snackbar
              open={snackOpen.open}
              autoHideDuration={3000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              onClose={() => setsnackOpen({ ...snackOpen, open: false })}
            >
              <Alert
                // onClose={handleClose}
                severity={snackOpen.severity}
                variant="filled"
                sx={{ width: "100%" }}
              >
                {snackOpen.message}
                {/* Add user Successfully */}
              </Alert>
            </Snackbar>
          </Box>
          {/* Render the CountryFilter */}
          {/* <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}> */}
          {/* <Toolbar sx={{ padding: "0 16px", marginBottom: "20px" }}> */}
          {drawerFilterOpen && (
            <Drawer
              anchor="right"
              open={drawerFilterOpen}
              onClose={() => handleFilterDrawer()}
              sx={{
                backgroundColor: "transparent",
                "& .MuiDrawer-paper": {
                  // This targets the paper component within the Drawer
                  backgroundColor: "transparent", // Make paper transparent
                  boxShadow: "none", // Optional: Remove any shadow
                  width: "50%",
                },
              }}
            >
              <Box
                display="flex"
                gap={3}
                sx={{
                  width: "100%",
                  display: "flex",
                  overflowX: "hidden",
                  maxWidth: "100%",
                  justifyContent: "space-btween",
                  height: "100%",
                  backgroundColor: "transparent",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#f5f5f5",
                    height: "3%",
                    padding: "13px",
                    margin: "30px 0 0 0",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "80%",
                    width: "4%",
                  }}
                >
                  <IconButton
                    onClick={() => handleFilterDrawer()}
                    sx={{ color: "black" }}
                  >
                    <CloseIcon sx={{ fontSize: "1.2rem" }} />
                  </IconButton>
                </Box>
                <Box sx={{ display: "flex", width: "100%", height: "100vh" }}>
                  {/* Sidebar for selecting the filter */}
                  <FilterSidebar
                    {...{
                      setSelectedFilter,
                      selectedFilter,
                      filters,
                      appliedFilters,
                    }}
                  />

                  {/* Filter content area */}
                  <Box
                    sx={{
                      flexGrow: 1,
                      backgroundColor: "#F9F9F9",
                      padding: "20px",
                    }}
                  >
                    {renderSelectedFilter()}
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        gap: "3%",
                        position: "fixed",
                        bottom: "20px",
                        ml: 3,
                        mr: 3,
                      }}
                    >
                      <ApplyButton handleApply={handleApplyFilters} />
                      <ResetButton handleReset={handleResetFilters} />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Drawer>
          )}{" "}
          <AddUsers
            value={isDrawerOpen}
            setValue={setIsDrawerOpen}
            index={indexUserView}
            setindexUser={setindexUser}
            fetchUsers={fetchUsers}
            setsnackOpen={setsnackOpen}
          />
          <ViewUser
            values={isDrawerOpenEdit}
            handleEdit={handleEdit}
            setValues={setIsDrawerOpenEdit}
            indexView={indexUserView}
          />
          {deleteDialog && (
            // <Dialog
            //   open={deleteDialog}
            //   keepMounted
            //   aria-describedby="alert-dialog-slide-description"
            //   maxWidth="lg"
            // >
            //   <DialogContent>
            //     <DialogContentText id="alert-dialog-slide-description">
            //       Are you sure you want to Delete?
            //     </DialogContentText>
            //   </DialogContent>
            //   <DialogActions>
            //     <Button
            //       sx={{ textTransform: "none" }}
            //       onClick={() => setDeleteDialog(false)}
            //     >
            //       Cancle
            //     </Button>
            //     <Button sx={{ textTransform: "none" }} onClick={handleDeleteAggree}>
            //     Confirm
            //     </Button>
            //   </DialogActions>
            // </Dialog>
            <Dialog
              open={deleteDialog}
            // onClose={handleCancelDelete}
            >
              <DialogTitle>Confirm Delete</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Do you really want to delete this entry?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setDeleteDialog(false)} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleDeleteAggree} color="secondary">
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
          )}
          <Box
            sx={{
              pt: "2rem",
              // display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box item xs={6} sx={{ paddingLeft: 0, display: "flex" }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  textDecoration: "underline",
                  paddingLeft: "0",
                }}
              >
                {"Roles and Permissions"}
              </Typography>
            </Box>

            <Box
              sx={{
                pt: "2rem",
                width: "100%",
                marginBottom: "1.2rem",
                display: "flex", // Enable Flexbox
                justifyContent: "space-between", // Spread content between left and right
                alignItems: "center", // Align items vertically in the center
              }}
            >
              {/* Left Buttons */}
              <Box sx={{ display: "flex", gap: "1rem" }}>
                <Button
                  variant="contained"
                  onClick={() => setShowRoles(false)} // Show Users
                  sx={{
                    fontSize: "14px",
                    color: "#FFFFFF",
                    textTransform: "none",
                    backgroundColor: "#1c486b",
                  }}
                >
                  List of Users
                </Button>
                {user?.companyAdmin || user?.groupManager ? null : (
                  <Button
                    variant="contained"
                    onClick={() => setShowRoles(true)} // Show Roles
                    sx={{
                      backgroundColor: "#e0e0e0",
                      fontSize: "14px",
                      color: "black",
                      textTransform: "none",
                      "&:hover": {
                        backgroundColor: "#1c486b",
                        color: "#FFFFFF",
                      },
                    }}
                  >
                    List of Roles
                  </Button>
                )}
              </Box>

              {/* Right Buttons */}
              <Box sx={{ display: "flex", gap: "1rem" }}>
                <Button
                  variant="contained"
                  onClick={() => setDrawerFilterOpen(true)}
                  sx={{
                    backgroundColor: "#ffffff",
                    color: "black",
                    "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
                  }}
                >
                  Filter
                  <FilterListIcon />
                  {isFiltersApplied && (
                    <FiberManualRecordIcon
                      sx={{
                        fontSize: "10px",
                        color: "#488257",
                        marginLeft: "5px",
                      }}
                    />
                  )}
                </Button>
                <Button
                  variant="contained"
                  endIcon={<AddIcon />}
                  sx={{
                    backgroundColor: "#1c486b",
                    fontSize: "14px",
                    textTransform: "none",
                  }}
                  onClick={() => handleAddUser(0)}
                >
                  Add New
                </Button>
              </Box>
            </Box>
          </Box>
          <TableContainer component={Paper}>
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  textAlign: "left",
                  padding: "16px",
                }}
              >
                {user?.groupManager ? "List of Groups" : "List of Users"}
              </Box>

              {/* Header Row */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "12% 15% 20% 25% 18% 10%",
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {/* <Box sx={{ padding: '12px', textAlign: 'center', borderRight: '1px solid #ddd' }}> */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "8px 16px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    // borderBottom: "1px solid #ddd",
                  }}
                >
                  <Typography sx={{ fontWeight: "bold" }}>Date</Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      // onClick={() => handleSort( "asc")}
                      onClick={() => handleSort("createdAt", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "createdAt" &&
                              sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      // onClick={() => handleSort("desc")}
                      onClick={() => handleSort("createdAt", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "createdAt" &&
                              sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    // borderBottom: "1px solid #ddd",
                  }}
                >
                  <Typography sx={{ fontWeight: "bold" }}>Country</Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("country", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "country" &&
                              sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("country", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "country" &&
                              sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    // borderBottom: "1px solid #ddd",
                  }}
                >
                  <Typography sx={{ fontWeight: "bold" }}>
                    {user?.groupManager ? "Group Name" : "Company Name"}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("company", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "company" &&
                              sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("company", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "company" &&
                              sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    // borderBottom: "1px solid #ddd",
                  }}
                >
                  <Typography sx={{ fontWeight: "bold" }}>
                    Name of Employee
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("name", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "name" &&
                              sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("name", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "name" &&
                              sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    // borderBottom: "1px solid #ddd",
                  }}
                >
                  <Typography sx={{ fontWeight: "bold" }}>
                    Name of Role
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("role", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "role" &&
                              sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("role", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "role" &&
                              sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Box>
                {/* <Box sx={{ padding: '12px', textAlign: 'left' }}> */}
                <Box
                  sx={{
                    padding: "12px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography sx={{ fontWeight: "bold" }}>Action</Typography>
                </Box>
              </Box>

              {/* Data Rows */}
              {users?.length === 0 ? (
                <Box>
                  <NoDataFound />
                </Box>
              ) : (
                <Box
                  key={user?._id}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "12% 15% 20% 25% 18% 10%",
                    // borderBottom: "1px solid #ddd",
                    // height: "40px",
                    // alignItems: "center",
                  }}
                >
                  {users?.map((user, index) => (
                    <>
                      <Typography
                        sx={{
                          padding: "8px 16px",
                          textAlign: "left",
                          borderRight: "1px solid #ddd",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          borderBottom: "1px solid #ddd",
                          fontSize: "14px",
                          color: "black",
                        }}
                      >
                        {/* {new Date(user.createdAt).toLocaleDateString()} */}
                        {new Date(user.createdAt).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })}
                      </Typography>
                      <Typography
                        sx={{
                          padding: "8px 12px",
                          textAlign: "left",
                          borderRight: "1px solid #ddd",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          borderBottom: "1px solid #ddd",
                          fontSize: "14px",
                          color: "black",
                        }}
                      >
                        {user.country || 
                         (user.companyAdmin && user?.country) ||
                         (user.companyAdmin && user.company?.admin?.countryCode?.split(' - ')[1]) ||
                         (user.companyAdmin && user.countryCode?.split(' - ')[1]) ||
                         ''}
                      </Typography>

                      <Typography
                        sx={{
                          padding: "8px 12px",
                          textAlign: "left",
                          borderRight: "1px solid #ddd",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          borderBottom: "1px solid #ddd",
                          fontSize: "14px",
                          color: "black",
                        }}
                      >
                        {user.company
                          ? user.company.companyName
                          : user?.groupManager
                            ? user.group.groupName
                            : "No Company"}
                      </Typography>

                      <Typography
                        sx={{
                          padding: "8px 12px",
                          textAlign: "left",
                          borderRight: "1px solid #ddd",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          borderBottom: "1px solid #ddd",
                          fontSize: "14px",
                          color: "black",
                        }}
                      >
                        {user.name}
                      </Typography>
                      <Typography
                        sx={{
                          padding: "8px 12px",
                          textAlign: "left",
                          borderRight: "1px solid #ddd",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          borderBottom: "1px solid #ddd",
                          fontSize: "14px",
                          color: "black",
                        }}
                      >
                        {user?.companyAdmin === true &&
                          user?.isSubCompanyAdmin === false
                          ? "Company Admin"
                          : user?.companyAdmin === true &&
                            user?.isSubCompanyAdmin === true
                            ? "Sub Company Admin"
                            : user?.facilityManger === true
                              ? "Facility Manager"
                              : user?.subGroupManager === true
                                ? "Sub Group Admin"
                                : user.role?.name || "N/A"}
                      </Typography>
                      <Box
                        sx={{
                          textAlign: "center",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        <IconButton
                          onClick={(event) =>
                            handleMenuClick(event, index, user)
                          }
                        >
                          <MoreHorizIcon
                            sx={{ fontWeight: "bold", color: "black" }}
                          />
                        </IconButton>
                        <Menu
                          anchorEl={anchorEl}
                          open={open && selectedUserIndex === index}
                          onClose={handleMenuClose}
                          PaperProps={{
                            sx: {
                              width: "120px",
                              border: "1px solid #ddd",
                              justifyItems: "center",
                            },
                          }}
                        >
                          {user?.companyAdmin && companyUser ? (
                            <>
                              <MenuItem
                                sx={{ fontSize: "14px" }}
                                onClick={() => handleView()}
                              >
                                <AssignmentIcon
                                  sx={{
                                    marginRight: "10px",
                                    fontSize: "large",
                                  }}
                                />
                                View Logs
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "14px" }}
                                onClick={() => handleEdit()}
                              >
                                <EditIcon
                                  sx={{
                                    marginRight: "10px",
                                    fontSize: "large",
                                  }}
                                />
                                Edit
                              </MenuItem>
                              {canDeleteUser(user) && (
                                <MenuItem
                                  sx={{ fontSize: "14px" }}
                                  onClick={() => handleDelete(user)}
                                >
                                  <DeleteIcon
                                    sx={{
                                      marginRight: "10px",
                                      fontSize: "large",
                                    }}
                                  />
                                  Delete
                                </MenuItem>
                              )}
                            </>
                          ) : user?.facilityManger ? (
                            <>
                              <MenuItem
                                sx={{ fontSize: "14px" }}
                                onClick={() => handleView()}
                              >
                                <AssignmentIcon
                                  sx={{
                                    marginRight: "10px",
                                    fontSize: "large",
                                  }}
                                />
                                View Logs
                              </MenuItem>
                              {companyUser && canDeleteUser(user) && (
                                <MenuItem
                                  sx={{ fontSize: "14px" }}
                                  onClick={() => handleDelete(user)}
                                >
                                  <DeleteIcon
                                    sx={{
                                      marginRight: "10px",
                                      fontSize: "large",
                                    }}
                                  />
                                  Delete
                                </MenuItem>
                              )}
                            </>
                          ) : (
                            <>
                              <MenuItem
                                sx={{ fontSize: "14px" }}
                                onClick={() => handleView()}
                              >
                                <AssignmentIcon
                                  sx={{
                                    marginRight: "10px",
                                    fontSize: "large",
                                  }}
                                />
                                View Logs
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "14px" }}
                                onClick={() => handleEdit()}
                              >
                                <EditIcon
                                  sx={{
                                    marginRight: "10px",
                                    fontSize: "large",
                                  }}
                                />
                                Edit
                              </MenuItem>
                              {canDeleteUser(user) && (
                                <MenuItem
                                  sx={{ fontSize: "14px" }}
                                  onClick={() => handleDelete(user)}
                                >
                                  <DeleteIcon
                                    sx={{
                                      marginRight: "10px",
                                      fontSize: "large",
                                    }}
                                  />
                                  Delete
                                </MenuItem>
                              )}
                            </>
                          )}
                        </Menu>
                      </Box>
                    </>
                  ))}
                </Box>
              )}
            </Box>
          </TableContainer>
          {totalPages > 1 && (
            <PaginationBox
              totalPages={totalPages}
              page={page}
              handleChangePage={handleChangePage}
              StyledPaginationItem={StyledPaginationItem}
              isShortContent={isShortContent} // Pass this state to PaginationBox
            />
          )}
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default User;
